import * as Yup from 'yup';

const addCitySchema = Yup.object({
  CityDescription: Yup.string().required('City is required'),
});

export default addCitySchema;
